import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { courseStatusApi } from "./courseStatusApi";

export const useCourseStatus = (courseId: number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_STATUS_BY_ID(courseId),
    queryFn: () => courseStatusApi.fetchById(courseId),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_STATUS_BY_ID(courseId),
    });
  };

  return { invalidate, isLoading, isFetching, status: data?.data };
};
